import { ReactNode, createContext, useContext } from 'react'

interface AppShellContextValue {
  openLogin: () => void
  openRegister: () => void
  startLearning: () => void
}

const noop = () => {}

const AppShellContext = createContext<AppShellContextValue>({
  openLogin: noop,
  openRegister: noop,
  startLearning: noop,
})

interface AppShellProviderProps {
  children: ReactNode
  value: AppShellContextValue
}

export const AppShellProvider = ({ children, value }: AppShellProviderProps) => (
  <AppShellContext.Provider value={value}>
    {children}
  </AppShellContext.Provider>
)

export const useAppShell = () => useContext(AppShellContext)
